export default __webpack_public_path__ + "static/media/net.058ff728.png";